import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import PageHeader from "@/components/feature/PageHeader";
import { siteMeta, faqs } from "@/mocks/manga";

export default function Faq() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <Seo
        title={`常见问题 - ${siteMeta.name}`}
        description={`${siteMeta.name}常见问题：关于甜蜜惩罚漫画单行本卷数、全彩版本、番外收录与阅读方式的解答。`}
        keywords={siteMeta.keywords}
        canonicalPath="/faq"
        schema={faqSchema}
      />

      <PageHeader
        title="常见问题"
        subtitle="关于甜蜜惩罚漫画的卷数、全彩、番外与阅读方式的常见解答。"
        crumbs={[{ label: "首页", to: "/" }, { label: "常见问题" }]}
      />

      <div className="bg-background-50 py-12 md:py-16">
        <div className="mx-auto max-w-3xl px-4 md:px-6">
          <div className="space-y-4">
            {faqs.map((f) => (
              <details key={f.q} className="group rounded-2xl bg-background-100 p-5 open:bg-background-100 md:p-6">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-semibold text-foreground-950 md:text-base">
                  {f.q}
                  <i className="ri-add-line text-primary-600 transition-transform group-open:rotate-45"></i>
                </summary>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
              </details>
            ))}
          </div>

          <div className="mt-10 rounded-3xl bg-background-100 p-6 text-center md:p-8">
            <h2 className="font-heading text-lg font-bold text-foreground-950">没有找到你想要的答案？</h2>
            <p className="mt-2 text-sm text-foreground-600">欢迎通过联系我们页面提出你的问题。</p>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
            >
              联系我们
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}